import { render, staticRenderFns } from "./ShareLinkItem.vue?vue&type=template&id=bec2e620&"
import script from "./ShareLinkItem.vue?vue&type=script&lang=ts&"
export * from "./ShareLinkItem.vue?vue&type=script&lang=ts&"
import style0 from "./ShareLinkItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports